<template>
  <div class="qk-chart-scatter">
    <div ref="workspace"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "QkChartScatter", // 这个名字很重要，它就是未来的标签名 <qk-chart-scatter></qk-chart-scatter>
  props: {
    title: {
      // 标题
      type: String,
      default: "散点图",
    },
    width: {
      // 宽度
      type: [String, Number],
      default: 375,
    },
    height: {
      // 高度
      type: [String, Number],
      default: 275,
    },
    dataSrc: {
      // 数据源
      type: Object,
      default: () => {
        return {
          xAxis: {
            data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          },
          yAxis: {},
          series: [
            {
              type: "scatter",
              data: [220, 182, 191, 234, 290, 330, 310],
            },
          ],
        };
      },
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  computed: {
    // outerStyle() {
    //   return this.width
    //     ? {
    //         width: `${this.width}px`,
    //       }
    //     : {}
    // },
  },
  watch: {
    title(val) {
      // 绘制标题
      this.chart &&
        this.chart.setOption({
          title: {
            text: val || "",
          },
        });
    },
    width(val) {
      // 重新绘制
      this.chart &&
        this.chart.resize({
          width: val,
          height: this.height,
        });
    },
    height(val) {
      // 重新绘制
      this.chart &&
        this.chart.resize({
          width: this.width,
          height: val,
        });
    },
    dataSrc() {
      // 重新绘制
      this.chart && this.init();
    },
  },
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.chart = echarts.init(this.$refs.workspace, null, {
      width: this.width,
      height: this.height,
    });
    this.init();
  },
  methods: {
    init() {
      // 绘制图表
      this.chart.setOption({
        title: {
          text: this.title,
        },
        // tooltip: {},
        ...this.dataSrc,
      });
    },
  },
};
</script>
<!-- <style lang="scss" scoped>
.qk-chart-scatter {
}
</style> -->
